<template>
    <div class="permission-container">
        <div class="permission-tips">{{description}}</div>
        <a-button type="primary" class="permission-btn" @click="relogin">重新登录</a-button>
    </div>
</template>
<script>
import { redirectLogin } from "@/utils";

export default {
	name: "AppPermission",
	data() {
		return {
			description: "您暂无权限访问，请联系管理员添加权限",
		};
	},

	methods: {
		relogin() {
			redirectLogin();
		},
	},
};
</script>

<style lang="less" scoped>
.permission {
    &-container {
        overflow: hidden;
    }
    &-tips {
        margin-top: 200px;
        font-size: 36px;
        font-weight: bold;
        text-align: center;
        color: #409eff;
    }

    &-btn {
        display: block;
        width: 100px;
        margin: 50px auto 0;
        padding: 3px 5px;
        color: #fff;
        border-radius: 3px;
        text-align: center;
        cursor: pointer;
    }
}
</style>
